import requestAxios from '@/utils/request'

export function getListStudentApi (params) {
  return requestAxios.get('enter-score/student', {params})
}



// WEBPACK FOOTER //
// ./src/api/enter-score/student.js